exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  width: 70%; \r\n  margin: auto;\r\n  position:absolute;\r\n  top:0;\r\n  left:0;\r\n  right:0;\r\n  bottom:0;\r\n}\r\n\r\n\r\n.inner-sidenav-content {\r\n  overflow: auto;\r\n  position: absolute;\r\n  bottom:0;\r\n  left:0;\r\n  right:0;\r\n  top:75px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/dev/Perso/urmeo/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main